import { FC, useCallback } from 'react'
import styled from 'styled-components'
import useJobCategoryStore from '../../store/store.jobCategory'
import { TJobCategory } from '../../type/jobCategoryStoreType'
import DrawSelectedItem, { TDrawSelectedItemInfo } from './DrawSelectedItem'

interface IFSelectedItemProps {
  category: TJobCategory
  onDelete?: (category: TJobCategory) => void
  className?: string
}

const SelectedItem: FC<IFSelectedItemProps> = ({
  category,
  onDelete,
  className,
}) => {
  const { id, selectedChildrenIds } = category

  const unSelectId = useJobCategoryStore((state) => state.unSelectId)
  const unSelectIdWithChildren = useJobCategoryStore(
    (state) => state.unSelectIdWithChildren,
  )
  const getChainingLabelById = useJobCategoryStore(
    (state) => state.getChainingLabelById,
  )

  const SelectedItem: TDrawSelectedItemInfo = {
    id,
    label: getChainingLabelById(id),
  }

  const handleDeleteItem = useCallback(
    (selectedItemId: string) => {
      onDelete && onDelete(category)
      if (selectedChildrenIds.length !== 0) {
        return unSelectIdWithChildren(selectedItemId)
      }
      unSelectId(selectedItemId)
    },
    [unSelectId, unSelectIdWithChildren, selectedChildrenIds, onDelete],
  )

  return (
    <StyledWrapper
      selectedItem={SelectedItem}
      onDelete={handleDeleteItem}
      className={className}
    />
  )
}

export default SelectedItem

const StyledWrapper = styled(DrawSelectedItem)``
